import styled, { keyframes } from "styled-components";
import { ReactComponent as circularLoading } from "assets/images/minting/circularLoading.svg";
import { Flex } from "Element/Flex";

export const RotateAnimation = keyframes`
  from{
    transform: rotate(-90deg)
  }
  to{
    transform: rotate(270deg)

  }
`;

export const LoadingWrapper = styled(Flex)`
  position: relative;
`;
export const WienerImg = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const LoadingDot = styled(circularLoading)`
  position: relative;
  animation: ${RotateAnimation} 5s linear infinite;
`;
